const messages = {
  title: "Listas de preços e brochuras de produtos",
  description:
    "Descarregue aqui os folhetos e brochuras mais recentes sobre os pneus Bridgestone e Firestone para automóveis ligeiros, SUV e veículos comerciais.",
  brochureCategories: {
    products: "Produtos",
    brand_and_solutions: "Marca e soluções",
    season_and_promotions: "Época e promoções",
    format: "Formato",
    cars_and_vans: "Ligeiro, SUV, utilitário",
    summer: "Verão",
    winter: "Inverno",
    promotions: "Promoções",
    all_season: "Todas as estações",
    truck_and_buses: "Pesado e autocarro",
    motorcycle: "Motociclo",
    agriculture: "Agricultura",
    construction_machinery: "Máquinas de construção",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiais",
    brochures: "Brochuras de produto",
    price_list: "Listas de preços",
    materials: "Materiais",
    video_in_store: "Vídeo com legendas",
    video_online: "Vídeo sem legendas",
    banner_website: "Banner",
    banner_social_media: "Redes sociais",
    logos: "Logótipos",
  },
  searchMedia: "Introduza uma palavra-chave",
  searchResults: "Resultados da pesquisa",
};

export default {
  messages,
};
